// this file was auto-generated by rake i18n:generate_js.
// you probably shouldn't edit it directly
import mergeI18nTranslations from 'mergeI18nTranslations';

// we use JSON.parse here instead of just loading it as a javascript object literal
// because according to https://v8.dev/blog/cost-of-javascript-2019#json that is faster
mergeI18nTranslations(JSON.parse("{\"de\":{\"expand_global_navigation_2c28d5d4\":\"Globale Navigation erweitern\",\"minimize_global_navigation_2d839351\":\"Globale Navigation minimieren\"},\"hu\":{\"minimize_global_navigation_2d839351\":\"Globális navigáció minimalizálása\"}}"));
